import { useCallback, useEffect, useState } from 'react';
import { fetchMisData } from '../utils/dashboardUtils';

export function useMaintenanceData() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [key, setKey] = useState(0);
  const refresh = useCallback(() => setKey((k) => k + 1), []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const data = await fetchMisData('/maintenance');
        if (!cancelled) {
          setRecords([...data].sort((a, b) => new Date(b.AssignDate) - new Date(a.AssignDate)));
          setError(null);
        }
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [key]);

  return { records, loading, error, refresh };
}

export function useWarrantyData() {
  const [supplyRows, setSupplyRows] = useState([]);
  const [warrantyRows, setWarrantyRows] = useState([]);
  const [rejectionRows, setRejectionRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [key, setKey] = useState(0);
  const refresh = useCallback(() => setKey((k) => k + 1), []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const [supply, warranty, rejection] = await Promise.all([
          fetchMisData('/supply'),
          fetchMisData('/warranty'),
          fetchMisData('/rejection'),
        ]);
        if (!cancelled) {
          setSupplyRows(supply);
          setWarrantyRows(warranty);
          setRejectionRows(rejection);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) setError(e.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [key]);

  return { supplyRows, warrantyRows, rejectionRows, loading, error, refresh };
}
